import React from "react";
import Router from "../../routes/Router";
import "./Body.css";
import { MedicalEmergencyProvider } from "./screens/MedicalEmergenciesMainScreen/context/MedicalEmergencyContext";
import { Box, Card, Text } from "grommet";
import { useUser } from "../context/User/UserContext";
import { useStore } from "../../../Hooks/useStore";
import { observer } from "mobx-react";

function Body(props) {
  const { user, setUser } = useUser();
  const { rootStore } = useStore();
  const { currentRoutePath } = props;
  return (
    <div className="body-container" style={{height: currentRoutePath.indexOf("/call") == -1 ? "calc(100vh - 142px)" : "100vh"}}>
      <MedicalEmergencyProvider>
        <Router />
      </MedicalEmergencyProvider>
    </div>
  );
}

export default observer(Body);
